import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import TipoCargo from './TipoCargo';
import ACCESS from '../../../ACCESS.js';

class Tipos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cargo-credito-tipo/filter', deleteUrl: 'cargo-credito-tipo/delete', deleteField: 'cc_tipo', modUrl: '/Catalogo/TipoCargo' },
      TableOp.Table('Tipo Cargo-Credito', [
        { label: 'Tipo', id: 'cc_tipo' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_TIPOS_DE_CARGOS_CREDITOS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_TIPOS_DE_CARGOS_CREDITOS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <TipoCargo  onSave={() => {this.table()}}></TipoCargo>
          }
          {
             
          <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(Tipos)